import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-dashboard-broadcast-screens-card',
  templateUrl: './dashboard-broadcast-screens-card.component.html',
  styleUrls: ['./dashboard-broadcast-screens-card.component.scss']
})
export class DashboardBroadcastScreensCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('screens-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('screens-counts-spinner');
      this.showCounter = true;
      // this.count = this.data.filter(d => d.deviceTypeName === 'TV').length;
      this.count = this.data.length;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
      this.spinnerService.hide('screens-counts-spinner');
    }
  }

}
